// TODO: Use fetch hook for simplicity
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ScrollableContext } from 'bv-contexts';

import BannerNav from './components/banner_nav';
import BannerSlider from './components/banner_slider';

const Banners = ({
  banners,
  className,
  hasNav,
}) => {
  const [activeSlide, setActiveSlide] = useState(-1);
  const [prevIndex, setPrevIndex] = useState(-1);
  let bannerTimeOut;

  const jumpToSlide = (index) => {
    clearTimeout(bannerTimeOut);
    setActiveSlide(index);
    setPrevIndex(index - 1);
  };

  const scrollableRef = useRef();

  useEffect(() => () => { clearTimeout(bannerTimeOut); }, [banners]);

  // TODO: Timeout code seems duplicated, have a look, simplify and improve
  useEffect(() => {
    if (banners.length > 1) {
      setTimeout(() => {
        setActiveSlide(1);
        setPrevIndex(0);
      }, 7000);
    }
  }, [banners.length]);

  useEffect(() => {
    if (activeSlide !== -1) {
      bannerTimeOut = setTimeout(
        () => {
          setPrevIndex(activeSlide);
          setActiveSlide((activeSlide + 1) % banners.length);
        },
        7000,
      );
    }
  }, [activeSlide]);

  return (
    <ScrollableContext.Provider value={scrollableRef}>
      <div
        className={classnames(
          'site-main-banner-wrapper', className, {
            'site-main-banner-wrapper--collapsed': !banners.length,
            'site-main-banner-wrapper--single': banners.length === 1,
            'site-main-banner-wrapper--wide': banners.length > 0 && banners[0].type === 'LayoutB',
          },
        )}
        ref={scrollableRef}
      >
        <div className="bv-slider">
          <BannerSlider banners={banners} prevIndex={prevIndex} activeIndex={activeSlide} />
          { hasNav && (
            <BannerNav
              banners={banners}
              activeIndex={activeSlide}
              prevIndex={prevIndex}
              jumpToSlide={jumpToSlide}
            />
          )}
        </div>
      </div>
    </ScrollableContext.Provider>
  );
};

Banners.propTypes = {
  banners: PropTypes.instanceOf(Array).isRequired,
  className: PropTypes.string,
  hasNav: PropTypes.bool,
};

Banners.defaultProps = {
  className: '',
  hasNav: false,
};

export default Banners;
